import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IPhoneNumberVerifications, IUserResponse } from "../../Orchestrator/Types/Index";


export async function postPhoneVerifications(userId: number, payload: any): Promise<IApiResponse<IPhoneNumberVerifications>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.phoneVerifications(userId);

    return await apiRequest<IPhoneNumberVerifications>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}


export async function postPhoneValidate(userId: number, payload: any): Promise<IApiResponse<IUserResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.phoneValidate(userId);

    return await apiRequest<IUserResponse>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}